import authStore from "../store/modules/auth.store";

export default function auth({ next, router }) {

  const { token } = authStore.state

  if (!token) return router.push({ name: "Authentication" });

  return next();
}
